import React, { Component } from 'react';
import { withRouter } from 'react-router';
import '../components/ProgressBar.css';
import Number_1_selected from '../../../assets/ProgressBar/Number_1_selected.svg';
import Number_1_selectedPng from '../../../assets/ProgressBar/Number_1_selected.png';
import Number_2 from '../../../assets/ProgressBar/Number_2.svg';
import Number_2Png from '../../../assets/ProgressBar/Number_2.png';
import Number_2_selected from '../../../assets/ProgressBar/Number_2_selected.svg';
import Number_2_selectedPng from '../../../assets/ProgressBar/Number_2_selected.png';
import Number_3 from '../../../assets/ProgressBar/Number_3.svg';
import Number_3Png from '../../../assets/ProgressBar/Number_3.png';
import Number_3_selected from '../../../assets/ProgressBar/Number_3_selected.svg';
import Number_3_selectedPng from '../../../assets/ProgressBar/Number_3_selected.png';
import Number_check from '../../../assets/ProgressBar/Number_check.svg';
import Number_checkPng from '../../../assets/ProgressBar/Number_check.png';
import HorizonNumber_1_selected from '../../../assets/ProgressBar/Horizon/Number_1_selected_hsb.svg';
import HorizonNumber_1_selectedPng from '../../../assets/ProgressBar/Horizon/Number_1_selected_hsb.png';
import HorizonNumber_2_selected from '../../../assets/ProgressBar/Horizon/Number_2_selected_hsb.svg';
import HorizonNumber_2_selectedPng from '../../../assets/ProgressBar/Horizon/Number_2_selected_hsb.png';
import HorizonNumber_3_selected from '../../../assets/ProgressBar/Horizon/Number_3_selected_hsb.svg';
import HorizonNumber_3_selectedPng from '../../../assets/ProgressBar/Horizon/Number_3_selected_hsb.png';
import HorizonNumber_check from '../../../assets/ProgressBar/Horizon/Number_check_hsb.svg';
import HorizonNumber_checkPng from '../../../assets/ProgressBar/Horizon/Number_check_hsb.png';
import {connect} from 'react-redux';
import { compose } from 'recompose';
import {updateProgressBar} from '../../../store/actions/consumerActions';
import { isMacOS } from '../../../utils/isMacOS';
import { isFirefox } from '../../../utils/isFirefox';
import { isHorizon } from "../../../utils/brandHelper";
class ProgressBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: 1,
      completed: [],
    }
  }

  componentDidMount() {
    this.setProgress();
  }

  componentDidUpdate(prevProps) {
    if(prevProps.shouldUpdateProgressBar !== this.props.shouldUpdateProgressBar && this.props.shouldUpdateProgressBar == true) {
      this.setProgress();
      this.props.updateProgressBar(false);
    }
  }

  setProgress() {
    switch (this.props.location.pathname) {
      case '/':
        this.setState({selected: 1, completed: []})
        window.scrollTo(0,0);
        break;
      case '/quotes-list':
        this.setState({selected: 2, completed: [1]})
        break;
      case '/application':
        this.setState({selected: 3, completed: [1,2]})
        break;
      case '/confirmation':
        this.setState({selected: null, completed: [1,2,3]})
        break;
      default:
        this.setState({selected: 1, completed: []})
        window.scrollTo(0,0);
        break;
    }
  }

  render() {
    const step1Completed = this.state.completed.includes(1);
    const step2Completed = this.state.completed.includes(2);
    const step3Completed = this.state.completed.includes(3);

    const images = isHorizon
    ? {
        number1: HorizonNumber_1_selected,
        number1Png: HorizonNumber_1_selectedPng,
        number2: Number_2,
        number2Png: Number_2Png,
        number2Selected: HorizonNumber_2_selected,
        number2SelectedPng: HorizonNumber_2_selectedPng,
        number3: Number_3,
        number3Png: Number_3Png,
        number3Selected: HorizonNumber_3_selected,
        number3SelectedPng: HorizonNumber_3_selectedPng,
        numberCheck: HorizonNumber_check,
        numberCheckPng: HorizonNumber_checkPng
      }
    : {
        number1: Number_1_selected,
        number1Png: Number_1_selectedPng,
        number2: Number_2,
        number2Png: Number_2Png,
        number2Selected: Number_2_selected,
        number2SelectedPng: Number_2_selectedPng,
        number3: Number_3,
        number3Png: Number_3Png,
        number3Selected: Number_3_selected,
        number3SelectedPng: Number_3_selectedPng,
        numberCheck: Number_check,
        numberCheckPng: Number_checkPng
      };


    
    return (
      <nav className={`d-flex align-items-center justify-content-between progressBarContainer ${!isMacOS() && "not-mac-os"}`}>
        <div className={`number-container p-relative ${this.state.selected == 1 ? "selected": step1Completed ? "completedStep":""}`}>
          <img src={!isMacOS() && isFirefox() ? (step1Completed ? images.numberCheckPng : images.number1Png) : (step1Completed ? images.numberCheck : images.number1)} />
          <p className="mb-0 label">Information</p>
        </div>
        <div style={{flex: 1}}></div>
        <div className={`number-container p-relative ${this.state.selected == 2 ? "selected": step2Completed ? "completedStep" : ""} ${step1Completed && !step2Completed ? "currentStep":""}`}>
          <img src={(!isMacOS() && isFirefox()) ? (step2Completed ? images.numberCheckPng : (this.state.selected == 2 ? images.number2SelectedPng : images.number2Png)) : (step2Completed ? images.numberCheck : (this.state.selected == 2 ? images.number2Selected : images.number2))} />
          <p className="mb-0 label">Quotes</p>
        </div>
        <div style={{flex: 1}}></div>
        <div className={`number-container p-relative ${this.state.selected == 3 ? "selected": step3Completed ? "completedStep" : ""} ${step2Completed && !step3Completed ? "currentStep":""}`}>
          <img src={(!isMacOS() && isFirefox()) ? (step3Completed ? images.numberCheckPng : (this.state.selected == 3 ? images.number3SelectedPng : images.number3Png)) : (step3Completed ? images.numberCheck : (this.state.selected == 3 ? images.number3Selected : images.number3))} />
          <p className="mb-0 label">Application</p>
        </div>
      </nav>
    );
  }
}

const mapStateToProps  = (state) => ({
  shouldUpdateProgressBar: state.consumer.shouldUpdateProgressBar,
})

export default compose(
  connect(mapStateToProps, {updateProgressBar}), 
  withRouter)(ProgressBar);
